import { AppLoading } from "@tracabois/components";
import { useRealizationMapQuery } from "../../api";
import { Box } from "@mui/material";
import { MapWithMarkers, MapMarker } from "@tracabois/components";
import { RealizationPopupCard } from "@tracabois/domain";
import { useMemo } from "react";

export const RealizationsMapEmbedPage = () => {
  const mapResult = useRealizationMapQuery({});

  const markers: MapMarker[] = useMemo(() => {
    const items = mapResult.data?.markers ?? [];
    const result: MapMarker[] = [];

    for (const item of items) {
      const coords = item.coordinates;
      if (!coords) continue;

      result.push({
        id: item.id,
        position: [coords.latitude, coords.longitude],
        tooltip: item.name,
        popup: (
          <RealizationPopupCard
            name={item.name}
            thumbnail={item.thumbnail}
            onClick={() => window.open(`/realizations/${item.id}`, "_blank")}
          />
        ),
        onClick: () => {},
      });
    }

    return result;
  }, [mapResult.data?.markers]);

  if (mapResult.isLoading) {
    return <AppLoading />;
  }

  return (
    <Box sx={{ height: "100vh", width: "100vw", backgroundColor: "#FFFFFF", position: "relative" }}>
      <MapWithMarkers
        markers={markers}
        height="100%"
        enableClustering={true}
        onMarkerClick={(id) => {
          console.log("Marker clicked:", id);
        }}
      />
    </Box>
  );
};
